import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { createFragmentContainer } from 'react-relay';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Link, ListItemText, ListItemIcon, Menu, MenuItem, TableContainer, Table,  TableBody, TableCell, TableHead, TableRow, Tooltip, Typography} from '@mui/material';
import CheckCircle from '@mui/icons-material/CheckCircle';
import PauseCircleFilled from '@mui/icons-material/PauseCircleFilled';
import CancelCircleOutline from '@mui/icons-material/Cancel';
import PauseCircleOutline from '@mui/icons-material/PauseCircleOutline';
import PlayCircleOutline from '@mui/icons-material/PlayCircleOutline';
import HourglassEmpty from '@mui/icons-material/HourglassEmpty';
import Edit from '@mui/icons-material/Edit';
import CallMade from '@mui/icons-material/CallMade';
import ConfirmationDialog from '../ui/ConfirmationDialog';

import Cancel from '@mui/icons-material/Cancel';
import AbEnvironment from '../auth/AbEnvironment';
import CustomerAppFetch from '../account/CustomerAppFetch';


import { green, red, blue, amber } from '@mui/material/colors';


const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
    paper: {
        width: '100%',
        marginTop: theme.spacing(1),
        overflow: 'auto',
    },
    tblHead: {
      backgroundColor: '#f1f1f1',
    },
    tblHeadRow: {
      height: 32,
    },
    tblHeadCell: {
      textAlign: 'left',
      verticalAlign: 'bottom',
      borderBottom: 0,
    },
    tblHeadCellB: {
      textAlign: 'right',
      verticalAlign: 'bottom',
    },
    tblHeadCellC: {
      textAlign: 'center',
      verticalAlign: 'bottom',
      borderBottom: 0,
    },
    tblHeadCellWidth100: {
      textAlign: 'center',
      verticalAlign: 'bottom',
      borderBottom: 0,
      width: 100
    },
    tblHeadRow2: {
      height: 24,
    },
    tblHeadCell2: {
      textAlign: 'center',
      verticalAlign: 'top',
      //borderBottom: 0,
    },
    tblHeadRow3: {
      height: 32,
    },
    markup: {
      color: '#666666'
    },
    appnameitem: {
      marginLeft: 8,
    },
    inactive: {
      fontStyle: 'italic'
    },
    editicon: {
      width: 22,
      height: 22,
    }
});

class SubscriptionsAcrossCustomerList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      customerAppId: '',
      customerAppName: '',
      activeMenu: null,
      activeSharedLoginMenu: null,
      sharedLoginSub: false,
      suspendedMenu: null,
      confirmCancel: false
    };
  }

  getCurrencyString(theValue) {
    if (isNaN(theValue))
      return '';

    let currencyString = Number(theValue)
        .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

    return currencyString;
  }

  getPositiveCurrencyString(theValue) {
    if (isNaN(theValue))
      return '';

    if (theValue > 0) {
        let currencyString = Number(theValue)
        .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

        return currencyString;
    }
    return '';
  }

  goToExternalApp(action, customerAppId, appId, appLink) {
    abEnvironment.goToExternalApp(action, customerAppId, appId, appLink);
  }

  goTo(url) {
    /*
    const sterm = this.props.sterm;
    if (sterm != null)
    {
        localStorage.setItem('appsSterms', sterm);
    }
    */
    this.props.history.push(`${url}`);
  }

  
  handleSuspendedMenuClose = () => {
    this.setState({suspendedMenu: null});
  }
  handleSuspendedMenuClick = (event, customerAppId, customerAppName) => {
    this.setState({suspendedMenu: event.currentTarget, customerAppId: customerAppId, customerAppName: customerAppName});
  }

  handleActiveMenuClose = () => {
    this.setState({activeMenu: null});
  }

  handleActiveMenuClick = (event, customerAppId, customerAppName) => {
    this.setState({activeMenu: event.currentTarget, customerAppId: customerAppId, customerAppName: customerAppName});
  }

  
  handleActiveSharedLoginMenuClose = () => {
    this.setState({activeSharedLoginMenu: null});
  }

  handleActiveSharedLoginMenuClick = (event, customerAppId, customerAppName) => {
    this.setState({activeSharedLoginMenu: event.currentTarget, customerAppId: customerAppId, customerAppName: customerAppName});
  }

  render() {
    const classes = this.props.classes;
    const thenodes = this.props.sl.nodes;
    const statusOk = green[300];
    const statusPause = blue[300];
    const statusWaiting = amber[400];
    const statusCancel = red[300];

    let myAccountId = abEnvironment.getUserAttribute("a_id");

    // Get the summary data from the last entry
    let thisMonthCharge = 0;
    let lastMonthCharge = 0;
    let ytdCharge = 0;

    let lastIdx = thenodes.length-1;
    if (lastIdx >= 0)
    {
      let lastNode = thenodes[lastIdx];
      thisMonthCharge = lastNode.ttlTmBcSum;
      lastMonthCharge = lastNode.ttlLmBcSum;
      ytdCharge = lastNode.ttlYtdBcSum;
      
    }

    // Reseller's view of customer subscriptions
    let thisMonthChargeSummary = this.getCurrencyString(thisMonthCharge);
    let lastMonthChargeSummary = this.getCurrencyString(lastMonthCharge);
    let ytdChargeSummary       = this.getCurrencyString(ytdCharge);

    // make sure link url is prefixed correctly
    let appUrlWithProtocol = '';
    if (this.props.loginLink && this.props.loginLink !== '') {
      let ll = this.props.loginLink;
      appUrlWithProtocol = (ll.startsWith("http://") || ll.startsWith("https://")) ? ll :  "https://" + ll;
    }

    return (
      <div className={classes.paper}>
        <TableContainer>
          <Table>
            <TableHead className={classes.tblHead}>
              <TableRow className={classes.tblHeadRow}>
                <TableCell className={classes.tblHeadCell}></TableCell>
                <TableCell className={classes.tblHeadCell}></TableCell>
                <TableCell className={classes.tblHeadCellB}>Last&nbsp;30&nbsp;days</TableCell>
                <TableCell className={classes.tblHeadCellB}>Previous&nbsp;30&nbsp;days</TableCell>
                <TableCell className={classes.tblHeadCellB}>Year&nbsp;to&nbsp;date</TableCell>
                <TableCell className={classes.tblHeadCell} colSpan={3}/>
              </TableRow>
              <TableRow className={classes.tblHeadRow3}>
                <TableCell></TableCell>
                <TableCell>Who</TableCell>
                <TableCell align="right"><Typography variant="subtitle2">{thisMonthChargeSummary}</Typography></TableCell>
                <TableCell align="right"><Typography variant="subtitle2">{lastMonthChargeSummary}</Typography></TableCell>
                <TableCell align="right"><Typography variant="subtitle2">{ytdChargeSummary}</Typography></TableCell>
                <TableCell align="right">Model</TableCell>
                <TableCell align="center">Status</TableCell>
                <TableCell align="center"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>

            <Menu
                id="action-menu"
                anchorEl={this.state.activeMenu}
                open={Boolean(this.state.activeMenu)}
                onClose={this.handleActiveMenuClose}>
                <MenuItem onClick={() => {this.suspend()}}>
                  <ListItemIcon>
                    <PauseCircleOutline />
                  </ListItemIcon>
                  <ListItemText primary="Suspend"/>
                </MenuItem>
                <MenuItem onClick={() => {this.confirmCancel(false)}}>
                  <ListItemIcon>
                    <CancelCircleOutline htmlColor={statusCancel}/>
                  </ListItemIcon>
                  <ListItemText primary="Cancel"/>
                </MenuItem>
              </Menu>

              <Menu
                id="action-menu"
                anchorEl={this.state.activeSharedLoginMenu}
                open={Boolean(this.state.activeSharedLoginMenu)}
                onClose={this.handleActiveSharedLoginMenuClose}>
                <MenuItem onClick={() => {this.confirmCancel(true)}}>
                  <ListItemIcon>
                    <CancelCircleOutline htmlColor={statusCancel}/>
                  </ListItemIcon>
                  <ListItemText primary="Cancel"/>
                </MenuItem>
              </Menu>
              <Menu
                id="suspended-menu"
                anchorEl={this.state.suspendedMenu}
                open={Boolean(this.state.suspendedMenu)}
                onClose={this.handleSuspendedMenuClose}>
                <MenuItem onClick={() => {this.unsuspend()}}>
                  <ListItemIcon>
                    <PlayCircleOutline htmlColor={statusOk}/>
                  </ListItemIcon>
                  <ListItemText primary="Unsuspend"/>
                </MenuItem>
                <MenuItem onClick={() => {this.confirmCancel(false)}}>
                  <ListItemIcon>
                    <CancelCircleOutline htmlColor={statusCancel}/>
                  </ListItemIcon>
                  <ListItemText primary="Cancel"/>
                </MenuItem>
              </Menu>

              { thenodes.map(n => {
                let tmBcSum = this.getCurrencyString(n.tmBcSum);
                let lmBcSum = this.getCurrencyString(n.lmBcSum);
                let ytdBcSum = this.getCurrencyString(n.ytdBcSum);

                // Derive the model
                let theModel = 'Expense to me';
                if (n.accountId !== myAccountId) {
                  if (n.cappPaymentOrder === 1) {
                    let theMarkup = Number(n.cappMarkupPercentage);
                    if (theMarkup >= 0) {
                      theModel = parseFloat(theMarkup).toFixed(2) + '% markup';
                    } else {
                      theMarkup = theMarkup * -1;
                      theModel = parseFloat(theMarkup).toFixed(2) + '% discount';
                    } 
                  } else if (n.cappPaymentOrder === 0) {
                    let theMarkup = Number(n.cappMarkupPercentage);
                    if (theMarkup >= 0) {
                      theModel = parseFloat(theMarkup).toFixed(2) + '% markup';
                    } else {
                      theMarkup = theMarkup * -1;
                      theModel = parseFloat(theMarkup).toFixed(2) + '% discount';
                    } 
                  }
                }

                if (n.bcStatus === 4) {
                  //this is an auth only subscription so blank out fields that do not apply
                  tmBcSum = '';
                  lmBcSum = '';
                  ytdBcSum = '';
                  theModel = 'Shared login';
                }

                let sublink = 'subscription?customerAppId=' + n.customerAppId + '&fp=App';
                let customerLink = null;

                if (myAccountId !== n.accountId) {
                  customerLink = "./customer?accountId=" + n.accountId + '&fp=App';
                }

                if (n.customerAppStatus !== 2)
                {
                  let customerAppId = n.customerAppId;
                  let customerAppName = n.appName;

                  return (
                    <TableRow key={n.customerAppId}>
                      <TableCell>
                        <Grid container justifyContent="flex-start" alignItems="center">
                            
                          <Grid item >
                              <Button
                                color="primary"
                                onClick={this.goTo.bind(this, sublink)}>
                                <Edit className={classes.editicon}/>
                              </Button>
                          </Grid>
                        </Grid>
                      </TableCell>
                      {customerLink &&
                        <TableCell align="left">
                          <Link component="button" 
                                  variant="body2"
                                  onClick={this.goTo.bind(this, customerLink)}>
                              {n.accountName}
                            </Link>
                        </TableCell>
                      }
                      {!customerLink &&
                        <TableCell align="left"><Typography variant="body2">{n.accountName}</Typography></TableCell>
                      }
                      <TableCell align="right"><Typography variant="body2">{tmBcSum}</Typography></TableCell>
                      <TableCell align="right"><Typography variant="body2">{lmBcSum}</Typography></TableCell>
                      <TableCell align="right"><Typography variant="body2">{ytdBcSum}</Typography></TableCell>

                      <TableCell align="right">
                        <Typography variant="body2">
                          {theModel}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        { n.customerAppStatus === 0  && n.bcStatus !== -1 && n.bcStatus !== 4 &&
                          <Button color="primary" 
                            aria-owns={this.state.activeMenu ? 'simple-menu': undefined}
                            aria-haspopup='true'
                            disabled={false}
                            onClick={(e) => this.handleActiveMenuClick(e, customerAppId, customerAppName)} >
                                <CheckCircle htmlColor={statusOk}/>
                          </Button>
                        }
                        { n.customerAppStatus === 0 && n.bcStatus !== -1 && n.bcStatus === 4 &&
                              
                            <Button color="primary" 
                              aria-owns={this.state.activeSharedLoginMenu ? 'simple-menu': undefined}
                              aria-haspopup='true'
                              disabled={false}
                              onClick={(e) => this.handleActiveSharedLoginMenuClick(e, customerAppId, customerAppName)} >
                                  <CheckCircle htmlColor={statusOk}/>
                            </Button>
                             
                        }

                        { n.customerAppStatus === 0 && n.bcStatus === -1 &&
                          <Tooltip title="Waiting for funding source to be put on file">
                            <HourglassEmpty htmlColor={statusWaiting}/>
                          </Tooltip>
                        }
                        { n.customerAppStatus === 1 &&
                            <Button color="primary" 
                              aria-owns={this.state.suspendedMenu ? 'simple-menu': undefined}
                              aria-haspopup='true'
                              disabled={false}
                              onClick={(e) => this.handleSuspendedMenuClick(e, customerAppId, customerAppName)} >

                                  <PauseCircleFilled htmlColor={statusPause}/>
                              
                            </Button>
                        }
                        { n.customerAppStatus === 2 &&
                          <Cancel htmlColor={statusCancel}/>
                        }
                      </TableCell>
                      <TableCell align="center">
                      { (this.props.fromAppEdit === true) && 
                        <Button color="primary" variant="outlined" 
                                disabled={appUrlWithProtocol === ""}
                                onClick={() => { this.goToExternalApp('appLogin', n.customerAppId, null, appUrlWithProtocol) }}>
                          Login<CallMade/>
                        </Button> 
                        }
                      </TableCell>
                    </TableRow>
                  );
                } else {
                  return (
                    <TableRow key={n.customerAppId}>
                      <TableCell>
                        <Grid container justifyContent="flex-start" alignItems="center">
                            
                          <Grid item >
                              <Button
                                color="primary"
                                onClick={this.goTo.bind(this, sublink)}>
                                <Edit className={classes.editicon}/>
                              </Button>
                          </Grid>
                        </Grid>
                      </TableCell>
                      {customerLink &&
                        <TableCell align="left" >
                          <Link component="button" className={classes.inactive}
                                  variant="body2"
                                  onClick={this.goTo.bind(this, customerLink)}>
                              {n.accountName}
                            </Link>
                        </TableCell>
                      }
                      {!customerLink &&
                        <TableCell align="left" className={classes.inactive}><Typography variant="body2">{n.accountName}</Typography></TableCell>
                      }
                      <TableCell align="right">
                        <Typography variant="body2" className={classes.inactive}>                           
                            {tmBcSum}
                        </Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Typography variant="body2" className={classes.inactive}>
                            {lmBcSum}
                        </Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Typography variant="body2"  className={classes.inactive}>
                            {ytdBcSum}
                          </Typography>
                      </TableCell>

                      <TableCell align="right">
                        <Typography variant="body2"  className={classes.inactive}>
                          {theModel}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        { n.customerAppStatus === 0  && n.bcStatus !== -1 &&
                          <CheckCircle htmlColor={statusOk}/>
                        }
                        { n.customerAppStatus === 0 && n.bcStatus === -1 &&
                          <Tooltip title="Waiting for funding source to be put on file">
                            <HourglassEmpty htmlColor={statusWaiting}/>
                          </Tooltip>
                        }
                        { n.customerAppStatus === 1 &&
                          <PauseCircleFilled htmlColor={statusPause}/>
                        }
                        { n.customerAppStatus === 2 &&
                          <Cancel htmlColor={statusCancel}/>
                        }
                      </TableCell>
                      <TableCell align="center"></TableCell>
                    </TableRow>
                  );
                }
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <ConfirmationDialog
            open={this.state.confirmCancel}
            onClose={() => { this.setState({confirmCancel:false});}}
            onConfirm={() => {this.cancel()}}
            onCancel={() => { }}
            title={"Cancel " + this.state.customerAppName + " subscription?"}
            cancelBtn="No"
            okBtn="Yes, cancel subscription"
            irreversibleAction={true}
          >
            {this.state.sharedLoginSub === true ? ' This subscription will only be visible when clicking the show cancelled subscriptions. ' : 
            'Cancelling this subscription will cancel the virtual purchase card causing all future charges to be declined.  '}

            Are you sure you want to proceed?
          </ConfirmationDialog>

      </div>
    );
  }
  async suspend() {

    const { logError } = this.props.auth;
    const { callPartnerApi } = this.props.auth;

    let aPjwt = abEnvironment.getPjwt();

    CustomerAppFetch.fetch(this.state.customerAppId).toPromise()
    .then(caf => {
 
      let payload = {
        operation: "updateSubscriptionStatus",
        params: {
          pJwt: aPjwt,
          provisioningAccountId: caf.customerAppTByCustomerAppId.provisioningAccountId,
          customerAccountId: caf.customerAppTByCustomerAppId.customerAccountId,
          customerAppId: this.state.customerAppId,
          status: 1
        }
      };
  
  
      callPartnerApi('appbind/generic',
                     'POST',
                     payload
      )
      .then(resp => {
        return resp.json();
      })
      .then(response => {
  
        window.location.reload();
        this.setState({activeMenu: null, suspendedMenu: null, customerAppId: '', customerAppName: ''});
      })
      .catch(error => {
        logError('Exception in trying to suspend: ' + error);
        this.setState({activeMenu: null, suspendedMenu: null, customerAppId: '', customerAppName: ''});
      }); 
  
    })
    .catch(err => {
      //nothing to do....
    })

    
  }

  async unsuspend() {

 
    const { logError } = this.props.auth;
    const { callPartnerApi } = this.props.auth;

    let aPjwt = abEnvironment.getPjwt();

    CustomerAppFetch.fetch(this.state.customerAppId).toPromise()
    .then(caf => {
 
      let payload = {
        operation: "updateSubscriptionStatus",
        params: {
          pJwt: aPjwt,
          provisioningAccountId: caf.customerAppTByCustomerAppId.provisioningAccountId,
          customerAccountId: caf.customerAppTByCustomerAppId.customerAccountId,
          customerAppId: this.state.customerAppId,
          status: 0
        }
      };
  
  
      callPartnerApi('appbind/generic',
                     'POST',
                     payload
      )
      .then(resp => {
        return resp.json();
      })
      .then(response => {
  
        window.location.reload();
        this.setState({activeMenu: null, suspendedMenu: null, customerAppId: '', customerAppName: ''});
      })
      .catch(error => {
        logError('Exception in trying to suspend: ' + error);
        this.setState({activeMenu: null, suspendedMenu: null, customerAppId: '', customerAppName: ''});
      }); 
  
    })
    .catch(err => {
      //nothing to do....
    })

  }
  
  confirmCancel = (sharedLogin) => {
    this.setState({confirmCancel: true, activeMenu: null, activeSharedLoginMenu: null, suspendedMenu: null, sharedLoginSub: sharedLogin});
  };

  async cancel() {
     this.setState({confirmCancel: false});
    

     
    const { logError } = this.props.auth;
    const { callPartnerApi } = this.props.auth;

    let aPjwt = abEnvironment.getPjwt();

    CustomerAppFetch.fetch(this.state.customerAppId).toPromise()
    .then(caf => {
 
      let payload = {
        operation: "updateSubscriptionStatus",
        params: {
          pJwt: aPjwt,
          provisioningAccountId: caf.customerAppTByCustomerAppId.provisioningAccountId,
          customerAccountId: caf.customerAppTByCustomerAppId.customerAccountId,
          customerAppId: this.state.customerAppId,
          status: 2
        }
      };
  
  
      callPartnerApi('appbind/generic',
                     'POST',
                     payload
      )
      .then(resp => {
        return resp.json();
      })
      .then(response => {
  
        window.location.reload();
        this.setState({activeMenu: null, activeSharedLoginMenu: null, suspendedMenu: null, customerAppId: '', customerAppName: '', confirmCancel: false});
      })
      .catch(error => {
        logError('Exception in trying to suspend: ' + error);
        this.setState({activeMenu: null, activeSharedLoginMenu: null, suspendedMenu: null, customerAppId: '', customerAppName: '', confirmCancel: false});
      }); 
  
    })
    .catch(err => {
      //nothing to do....
    })


  }
}

SubscriptionsAcrossCustomerList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default createFragmentContainer(withStyles(styleSheet)(SubscriptionsAcrossCustomerList), { sl: graphql`
  fragment SubscriptionsAcrossCustomerList_sl on SubscriptionChargeAcrossCustsConnection {
    nodes {
      ttlTmBcSum
      ttlLmBcSum
      ttlYtdBcSum
      ttlTmMkSum
      ttlLmMkSum
      ttlYtdMkSum
      accountId
      accountName
      appId
      appName
      appSku
      appLogo
      appSkuPrice
      appMarkupPercentage
      appMarkupAbsolute
      customerAppId
      customerAppStatus
      initiatedBy
      customerListSubscription
      customerViewSubscription
      bcStatus
      cappPaymentOrder
      cappSkuPrice
      cappMarkupPercentage
      cappMarkupAbsolute
      tmBcSum
      lmBcSum
      ytdBcSum
      tmMkSum
      lmMkSum
      ytdMkSum
      loginUrl
    }
  }
`});
